import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_MEMBER_DEVICE_SUBSCRIPTION_ORDER_CHECK_API,
	POST_MEMBER_DEVICE_ORDER_LIST_API
} from "@apis/apiPath";

const useMemberDeviceOrderApi = () => {
	const Ajax = useAjax();

	// 申請下拉選單
	const postMemberDeviceOrderListApi = useCallback(
		async (parameters) => {
			return await Ajax.post(POST_MEMBER_DEVICE_ORDER_LIST_API, parameters);
		},
		// eslint-disable-next-line
		[]
	);

	const getMemberDeviceSubscriptionOrderCheckApi = useCallback(
		async (memberID) => {
			return await Ajax.get(GET_MEMBER_DEVICE_SUBSCRIPTION_ORDER_CHECK_API(memberID));
		},
		// eslint-disable-next-line
		[]
	)
	return {
		postMemberDeviceOrderListApi,
		getMemberDeviceSubscriptionOrderCheckApi
	};
};

export default useMemberDeviceOrderApi;
